import { useEffect, useState } from "react";

const safeJsonParse = (raw, fallback) => {
  if (!raw || typeof raw !== "string") return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

// Optional: schema version so old stored values don’t break new code
export function useLocalStorageState(key, initialValue, { version = 1 } = {}) {
  const storageKey = `${key}__v${version}`;

  const [value, setValue] = useState(() => {
    const parsed = safeJsonParse(localStorage.getItem(storageKey), null);
    if (parsed === null || parsed === undefined) return initialValue;
    return parsed;
  });

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      // ignore quota / private mode errors
    }
  }, [storageKey, value]);

  return [value, setValue];
}
